import gql from 'graphql-tag';

export const SEND_NOTIFICATION_TO_ALL_USERS = gql`
  mutation SendNotificationToAllUsers($data: NotificationInput!) {
    sendNotificationToAllUsers(data: $data) {
      ... on Error {
        message
        statusCode
      }
      ... on Success {
        message
        response
      }
    }
  }
`;

export const SEND_NOTIFICATION_TO_USERS = gql`
  mutation SendNotificationToUsers($data: NotificationInput!) {
    sendNotificationToUsers(data: $data) {
      ... on Error {
        message
        statusCode
      }
      ... on Success {
        message
        response
      }
    }
  }
`;

export const UPDATE_NOTIFICATIONS = gql`
  mutation UpdatedScheduledNotifications(
    $filters: UpdateScheduleNotificationInput!
  ) {
    updatedScheduledNotifications(filters: $filters) {
      ... on Error {
        message
      }
      ... on Success {
        message
        response
      }
    }
  }
`;

export const GET_SCHEDULED_NOTIFICATIONS = gql`
  query GetAllNotifications($data: ScheduledNotificationQueryInput) {
    getAllNotifications(data: $data) {
      schedule {
        date
      }
      id
      type
      title
      draft
      isActive
      status
      category
      createdAt
    }
  }
`;

export const GET_SENT_NOTIFICATIONS = gql`
  query GetScheduledNotifications($input: ScheduledNotificationFilterInput) {
    getScheduledNotifications(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithNotifications {
        pagination {
          total
          page
          limit
        }
        data {
          title
          status
          type
          category
          isActive
          draft
          id
          createdAt
          updatedAt
          schedule {
            date
          }
        }
      }
    }
  }
`;

export const GET_NOTIFICATION_BY_ID = gql`
  query GetScheduledNotifications($input: ScheduledNotificationFilterInput) {
    getScheduledNotifications(input: $input) {
      ... on ResponseWithNotifications {
        message
        data {
          type
          title
          id
          emailBanner
          emailHeader
          from
          replyTo
          body
          buttonLabel
          buttonUrl
          addDisclosure
          disclosureType
          disclosure
          isRead
          language
          isActive
          status
          whatsappTemplateName
          category
          triggeredBySystem
          eventType
          createdAt
          whatsappTemplateId
          updatedAt
          metadata
          class
          draft
          instrumentId
          instrumentKey
          assetClassKey
          users {
            id
          }
          audience {
            category
            accredited
            activeInvestors
            profileCompletion
            lastAppVisit
            activeInvestor
            state
            city
            citizenStatus
            countryOfBirth
            countryOfCitizenship
            visaType
            country
            countryCode
            investmentHorizon
            annualNetIncome
            employmentStatus
            taxFilingStatus
            estimatedNetWorth
            investmentPreference
            investmentExperience
            investmentTarget
            recommendedPortfolioStrategy
            affiliations
            investmentGoals
            signupDateRange {
              to
              from
            }
            riskProfile
            signupDateDuration {
              value
              unit
            }
            verifiedInvestors
            buttonLabel
            buttonUrl
            assetClassKey
            instrumentKey
            instrumentId
            orderStatus
            orderDirection
            orderType
            assetClassKeys
            instrumentKeys
            instrumentIds
            orderDirections
            orderTypes
            isOrderOnHold
            isKycApproved
            isAmlApproved
            isDocumentCheckApproved
            isDabaPro
            orderTransactionDate {
              to
              from
            }
            walletTransactionCurrency
            walletTransactionType
            walletTransactionStatus
            walletTransactionDateRange {
              from
              to
            }
            walletTransactionPaymentMethod
            walletTransactionPaymentProvider
            walletTransactionMovement
            walletTransactionAmount {
              operator
              value
            }
            walletTransactionCurrencies
            walletTransactionTypes
            walletTransactionStatuses
            walletTransactionPaymentMethods
            walletTransactionPaymentProviders
            walletTransactionMovements
          }
          multilang {
            language
            title
            body
            emailHeader
            parent
          }
          schedule {
            date
            frequency
            selectedDays
            expires
          }
        }
      }
    }
  }
`;

export const TRANSLATE_TEXT = gql`
  mutation TranslateText(
    $sourceLang: SourceLanguage!
    $sourceText: String!
    $targetLang: TargetLanguage!
  ) {
    translateText(
      sourceLang: $sourceLang
      sourceText: $sourceText
      targetLang: $targetLang
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on Translation {
        targetText
      }
    }
  }
`;

export const UPDATE_NOTIFICATION_CLASS = gql`
  mutation UpsertNotificationClass($input: CreateNotificationClassInput) {
    upsertNotificationClass(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotificationClass {
        message
        data {
          id
          name
          key
          active
        }
      }
    }
  }
`;

export const UPDATE_USER_NOTIFICATION_PREFERENCE = gql`
  mutation UpdateUserNotificationPreferences(
    $input: UpdateUserNotificationPreferencesInput
  ) {
    updateUserNotificationPreferences(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithUser {
        data {
          email
          id
        }
        message
      }
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation DeleteScheduledNotifications(
    $filters: ScheduledNotificationFilterInput!
  ) {
    deleteScheduledNotifications(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithAnything {
        message
      }
    }
  }
`;

export const UPDATE_NOTIFICATION_STATUS = gql`
  mutation UpdateNotificationState($input: UpdateNotificationStateInput!) {
    updateNotificationState(input: $input) {
      ... on Success {
        message
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;
